module.exports = __webpack_public_path__ + "img/4-5.19a4ad4a.jpg";